import { Component } from "react";

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="card animate-fade-in text-center w-full mt-0">
          <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-4">Something Went Wrong</h2>
          <p className="text-error mb-4">An error occurred: {this.state.error?.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;